<script>
import api from '@/helpers/api'
import { required, helpers } from 'vuelidate/lib/validators'

export default {
  name: 'attribute-form-dialog.app',
  props: {
    visible: { type: Boolean, default: false },
    attributeId: { type: String }
  },
  data: () => ({
    attribute: {},
    isLoading: false
  }),
  methods: {
    reset () {
      this.attribute = {
        key: null,
        type: null,
        options: null
      }
    },
    onCancel () {
      this.$emit('update:visible', false)

      this.$nextTick(() => {
        this.reset()
      })
    },
    async init () {
      if (this.isUpdate) {
        let item = await api.attributes.fetch({
          id: this.attributeId
        })

        this.attribute = { ...item }
      } else this.attribute = {}
    },
    async onSave () {
      this.$v.$touch()
      let valid = !this.$v.$invalid

      if (valid) {
        try {
          let item
          this.isLoading = true
          if (this.isUpdate) {
            item = await api.attributes.update({
              ...this.attribute,
              id: this.attributeId
            })
          } else {
            item = await api.attributes.create({
              ...this.attribute
            })
          }
          this.$bvToast.toast(`Attribute '${this.attribute.name}' was added!`, {
            title: 'Attribute Added',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false

          this.$emit('created', item)
          this.onCancel()
        } catch (err) {
          this.$bvToast.toast(`${err}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    }
  },
  validations () {
    let validations = {
      attribute: {
        key: {
          required
        },
        type: {
          required
        }
      }
    }
    if (!this.isUpdate) {
      validations.attribute.key = {
        required,
        async unique (v) {
          return (
            !helpers.req(v) || (await api.attributes.keyIsUnique({ value: v }))
          )
        }
      }
    }
    return validations
  },
  watch: {
    attributeId: { handler: 'init', immediate: true },
    visible: {
      handler (v) {
        if (v) this.init()
      }
    }
  },
  computed: {
    isUpdate () {
      return !!this.attributeId
    },
    title () {
      return this.isUpdate ? 'Edit Attribute' : 'New Attribute'
    },
    saveBtnLabel () {
      return this.isUpdate ? 'Save Changes' : 'Create Attribute'
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="lg"
  >
    <g-form-error-wrapper :validations="$v.attribute.key">
      <template v-slot="{ errors, invalid }">
        <g-text-input
          v-model="attribute.key"
          :label="$t('Key')"
          :placeholder="$t('Unique Key')"
          :error-messages="errors"
          :is-valid="!invalid"
          v-on:blur="$v.attribute.key.$touch()"
          label-cols-sm="3"
        >
        </g-text-input>
      </template>
    </g-form-error-wrapper>
    <g-form-error-wrapper :validations="$v.attribute.type">
      <template v-slot="{ errors, invalid }">
        <g-select
          v-model="attribute.type"
          :label="$t('Type')"
          :placeholder="$t('Unique Key')"
          :options="[
            { value: null, text: '- Select a Type -' },
            { value: 'string', text: 'String' },
            { value: 'number', text: 'Number' }
          ]"
          :error-messages="errors"
          :is-valid="!invalid"
          v-on:blur="$v.attribute.type.$touch()"
          label-cols-sm="3"
        >
        </g-select>
      </template>
    </g-form-error-wrapper>

    <b-form-group label="Tags " label-for="product_tags" label-cols-sm="3">
      <g-tag-input
        v-model="attribute.options"
        size="sm"
        allow-create
        placeholder="Enter an option and press Enter..."
      />
    </b-form-group>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-button variant="link" @click="onCancel" class="mr-2"
            >Cancel</b-button
          >
          <b-btn variant="primary" class="btn-label" @click="onSave">
            <i class="bx bxs-save label-icon"></i>
            {{ saveBtnLabel }}
          </b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>
